import animateIntoView from '../../components/animateInView.js';

document.querySelectorAll('[data-animate-in-view]')
  .forEach(el => new animateIntoView(el));
